import React, {useState} from 'react'
import {Button, message} from 'antd';
import TestNumberModal from "./TestNumberModal";

function TestNumber(props) {
    const {selectedRowKeys} = props
    const [showModal, toggleModal] = useState(false)

    const onClickButton = () => {
        if (selectedRowKeys.length === 0) {
            message.error('Chưa chọn bản ghi nào')
        } else {
            _toggleModal()
        }
    }

    const _toggleModal = () => {
        toggleModal(!showModal)
    }

    return <>
        <Button className="ml-3" onClick={onClickButton} type="primary">Test số</Button>
        {showModal && <TestNumberModal showModal={showModal} toggleModal={_toggleModal} {...props}/>}
    </>
}

export default TestNumber
